/* This file is auto-generated */

import type { ContractPromise } from '@polkadot/api-contract';
import type { GasLimit } from '@727-ventures/typechain-types';
import { buildSubmittableExtrinsic } from '@727-ventures/typechain-types';
import type * as ArgumentTypes from '../types-arguments/capsule';
import type BN from 'bn.js';
import type { ApiPromise } from '@polkadot/api';

export default class Methods {
	readonly __nativeContract: ContractPromise;
	readonly __apiPromise: ApiPromise;

	constructor(nativeContract: ContractPromise, apiPromise: ApiPromise) {
		this.__nativeContract = nativeContract;
		this.__apiPromise = apiPromise;
	}
	/**
	 * mint
	 *
	 * @param { ArgumentTypes.AccountId } account,
	 * @param { (string | number | BN) } amount,
	 */
	mint(account: ArgumentTypes.AccountId, amount: string | number | BN, __options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'mint',
			[account, amount],
			__options,
		);
	}

	/**
	 * burn
	 *
	 * @param { ArgumentTypes.AccountId } account,
	 * @param { (string | number | BN) } amount,
	 */
	burn(account: ArgumentTypes.AccountId, amount: string | number | BN, __options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'burn',
			[account, amount],
			__options,
		);
	}

	/**
	 * holders
	 *
	 */
	holders(__options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'holders',
			[],
			__options,
		);
	}

	/**
	 * transfer
	 *
	 * @param { ArgumentTypes.AccountId } to,
	 * @param { (string | number | BN) } value,
	 * @param { Array<(number | string | BN)> } data,
	 */
	transfer(
		to: ArgumentTypes.AccountId,
		value: string | number | BN,
		data: Array<number | string | BN>,
		__options: GasLimit,
	) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'transfer',
			[to, value, data],
			__options,
		);
	}

	/**
	 * transferFrom
	 *
	 * @param { ArgumentTypes.AccountId } from,
	 * @param { ArgumentTypes.AccountId } to,
	 * @param { (string | number | BN) } value,
	 * @param { Array<(number | string | BN)> } data,
	 */
	transferFrom(
		from: ArgumentTypes.AccountId,
		to: ArgumentTypes.AccountId,
		value: string | number | BN,
		data: Array<number | string | BN>,
		__options: GasLimit,
	) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'transferFrom',
			[from, to, value, data],
			__options,
		);
	}

	/**
	 * renounceOwnership
	 *
	 */
	renounceOwnership(__options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'ownable::renounceOwnership',
			[],
			__options,
		);
	}

	/**
	 * owner
	 *
	 */
	owner(__options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'ownable::owner',
			[],
			__options,
		);
	}

	/**
	 * transferOwnership
	 *
	 * @param { ArgumentTypes.AccountId | null } newOwner,
	 */
	transferOwnership(newOwner: ArgumentTypes.AccountId | null, __options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'ownable::transferOwnership',
			[newOwner],
			__options,
		);
	}

	/**
	 * increaseAllowance
	 *
	 * @param { ArgumentTypes.AccountId } spender,
	 * @param { (string | number | BN) } deltaValue,
	 */
	increaseAllowance(
		spender: ArgumentTypes.AccountId,
		deltaValue: string | number | BN,
		__options: GasLimit,
	) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22::increaseAllowance',
			[spender, deltaValue],
			__options,
		);
	}

	/**
	 * approve
	 *
	 * @param { ArgumentTypes.AccountId } spender,
	 * @param { (string | number | BN) } value,
	 */
	approve(spender: ArgumentTypes.AccountId, value: string | number | BN, __options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22::approve',
			[spender, value],
			__options,
		);
	}

	/**
	 * balanceOf
	 *
	 * @param { ArgumentTypes.AccountId } owner,
	 */
	balanceOf(owner: ArgumentTypes.AccountId, __options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22::balanceOf',
			[owner],
			__options,
		);
	}

	/**
	 * allowance
	 *
	 * @param { ArgumentTypes.AccountId } owner,
	 * @param { ArgumentTypes.AccountId } spender,
	 */
	allowance(
		owner: ArgumentTypes.AccountId,
		spender: ArgumentTypes.AccountId,
		__options: GasLimit,
	) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22::allowance',
			[owner, spender],
			__options,
		);
	}

	/**
	 * allowances
	 *
	 * @param { ArgumentTypes.AccountId } owner,
	 */
	allowances(owner: ArgumentTypes.AccountId, __options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22::allowances',
			[owner],
			__options,
		);
	}

	/**
	 * psp22::transfer
	 *
	 * @param { ArgumentTypes.AccountId } to,
	 * @param { (string | number | BN) } value,
	 * @param { Array<(number | string | BN)> } data,
	 */
	'psp22::transfer'(
		to: ArgumentTypes.AccountId,
		value: string | number | BN,
		data: Array<number | string | BN>,
		__options: GasLimit,
	) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22::transfer',
			[to, value, data],
			__options,
		);
	}

	/**
	 * psp22::transferFrom
	 *
	 * @param { ArgumentTypes.AccountId } from,
	 * @param { ArgumentTypes.AccountId } to,
	 * @param { (string | number | BN) } value,
	 * @param { Array<(number | string | BN)> } data,
	 */
	'psp22::transferFrom'(
		from: ArgumentTypes.AccountId,
		to: ArgumentTypes.AccountId,
		value: string | number | BN,
		data: Array<number | string | BN>,
		__options: GasLimit,
	) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22::transferFrom',
			[from, to, value, data],
			__options,
		);
	}

	/**
	 * decreaseAllowance
	 *
	 * @param { ArgumentTypes.AccountId } spender,
	 * @param { (string | number | BN) } deltaValue,
	 */
	decreaseAllowance(
		spender: ArgumentTypes.AccountId,
		deltaValue: string | number | BN,
		__options: GasLimit,
	) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22::decreaseAllowance',
			[spender, deltaValue],
			__options,
		);
	}

	/**
	 * totalSupply
	 *
	 */
	totalSupply(__options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22::totalSupply',
			[],
			__options,
		);
	}

	/**
	 * domainSeparator
	 *
	 */
	domainSeparator(__options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22Permit::domainSeparator',
			[],
			__options,
		);
	}

	/**
	 * permit
	 *
	 * @param { ArgumentTypes.AccountId } owner,
	 * @param { ArgumentTypes.AccountId } spender,
	 * @param { (string | number | BN) } value,
	 * @param { (number | string | BN) } deadline,
	 * @param { ArgumentTypes.Signature } signature,
	 */
	permit(
		owner: ArgumentTypes.AccountId,
		spender: ArgumentTypes.AccountId,
		value: string | number | BN,
		deadline: number | string | BN,
		signature: ArgumentTypes.Signature,
		__options: GasLimit,
	) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22Permit::permit',
			[owner, spender, value, deadline, signature],
			__options,
		);
	}

	/**
	 * tokenDecimals
	 *
	 */
	tokenDecimals(__options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22Metadata::tokenDecimals',
			[],
			__options,
		);
	}

	/**
	 * contractType
	 *
	 */
	contractType(__options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22Metadata::contractType',
			[],
			__options,
		);
	}

	/**
	 * tokenName
	 *
	 */
	tokenName(__options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22Metadata::tokenName',
			[],
			__options,
		);
	}

	/**
	 * tokenSymbol
	 *
	 */
	tokenSymbol(__options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'psp22Metadata::tokenSymbol',
			[],
			__options,
		);
	}

	/**
	 * nonces
	 *
	 * @param { ArgumentTypes.AccountId } account,
	 */
	nonces(account: ArgumentTypes.AccountId, __options: GasLimit) {
		return buildSubmittableExtrinsic(
			this.__apiPromise,
			this.__nativeContract,
			'nonces::nonces',
			[account],
			__options,
		);
	}
}
